import type { PlaceCatalogEntry } from '@my-fullstack-app/trpc-types';
import type { PlaceRef } from '@my-fullstack-app/itinerary-types';

/**
 * Build a durable `PlaceRef` snapshot from a catalog pick. 2-decimal
 * lat/lng rounding caps stored precision at ~1 km — matches what we
 * already do for home / destination / stay / journey anchors.
 * `photoToken` + `photoAttribution` are pulled through so any UI
 * showing this PlaceRef can render a hero photo + the ToS-required
 * photographer credit without a fresh catalog lookup.
 */
export function placeRefFromEntry(entry: PlaceCatalogEntry): PlaceRef {
  return {
    id: entry.id,
    name: entry.name,
    address: entry.address,
    lat:
      typeof entry.lat === 'number' && Number.isFinite(entry.lat)
        ? Math.round(entry.lat * 100) / 100
        : undefined,
    lng:
      typeof entry.lng === 'number' && Number.isFinite(entry.lng)
        ? Math.round(entry.lng * 100) / 100
        : undefined,
    countryCode: entry.countryCode,
    photoToken: entry.photoToken,
    photoAttribution: entry.photoAttribution,
  };
}
